import api from './api';

// DTO para criação, espelhando o backend
export interface CreateObjetoSeguroREDto {
    descricao: string;
    coberturas: {
        coberturaId: number;
        valor: number;
    }[];
}

// Interface para o objeto retornado pela API
export interface ObjetoSeguroRE {
    id: number;
    descricao: string;
    coberturas: {
        id: number;
        valor: string; // O backend retorna como string
        cobertura: {
            id: number;
            nome: string;
        };
    }[];
}

const listarPorApolice = async (apoliceId: number): Promise<ObjetoSeguroRE[]> => {
    const response = await api.get(`/apolices/${apoliceId}/objetos-seguro-re`);
    return response.data;
};

const criar = async (apoliceId: number, data: CreateObjetoSeguroREDto): Promise<ObjetoSeguroRE> => {
    const response = await api.post(`/apolices/${apoliceId}/objetos-seguro-re`, data);
    return response.data;
};

const excluir = async (apoliceId: number, objetoReId: number): Promise<void> => {
    await api.delete(`/apolices/${apoliceId}/objetos-seguro-re/${objetoReId}`);
};

export const objetoSeguroREService = {
    listarPorApolice,
    criar,
    excluir,
};